import React from 'react';
import { DateToLocal } from 'components/dates';
import { Money } from 'components/formatting';

const emptyFieldValue = "-";
const dateFormat = "DD MMM YYYY";
const dateTimeFormat = "DD/MM/YYYY HH:mm";

// Formats one captured snapshot field for display according to its type.
export function buildFieldValue(field) {
    if (field.value == null || field.value === "") {
        return emptyFieldValue;
    }

    if (field.type === "date") {
        return <DateToLocal format={dateFormat}>{field.value}</DateToLocal>;
    }

    if (field.type === "datetime") {
        return <DateToLocal format={dateTimeFormat}>{field.value}</DateToLocal>;
    }

    if (field.type === "currency") {
        return <Money>{Number(field.value)}</Money>;
    }

    if (field.type === "bool") {
        return field.value ? "Yes" : "No";
    }

    return field.value;
}
